import React from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '@praxis/component-logging';
import ErrorContent from './ErrorContent.js';
import NotFound from '../NotFound/NotFound.js';
import featureFlag from '../../util/featureFlag.js';

// eslint-disable-next-line no-unused-vars
var AppRouter = function AppRouter(_ref) {
  var routes = _ref.routes;
  var location = useLocation();
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    key: location.pathname,
    FallbackComponent: ErrorContent
  }, /*#__PURE__*/React.createElement(Routes, null, routes.map(function (route) {
    var path = route.path,
      component = route.component,
      hideInEnvironment = route.hideInEnvironment;
    return featureFlag(hideInEnvironment, /*#__PURE__*/React.createElement(Route, {
      path: path,
      element: component
    }));
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(NotFound, null)
  })));
};

export { AppRouter as default };
